<template>
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Facturas entregadas</h3>
          <h6 class="text-muted">Últimas 30</h6>
        </div>
        <!-- <div class="col text-right">
          <base-button size="sm" type="primary">See all</base-button>
        </div> -->
      </div>
    </div>

    <div class="table-responsive">
      <base-table thead-classes="thead-light"
                  :data="tableData">
        <template slot="columns">
          <th>Factura</th>
          <th>Chofer</th>
          <th>Fecha entrega</th>
        </template>


        <template slot-scope="{row}">
          <th scope="row">
            <span style="font-size:15px">{{row.factura}}</span><br>
            <span class="text-muted" style="font-size:10px">{{row.clienteNombre}}</span>
          </th>
          <td>
            {{row.choferNombre}}
          </td>
          <td>
            {{row.timestamp | formatDate}}
          </td>
        </template>
        <base-pagination :page-count="10" v-model="pagination.default"></base-pagination>
      </base-table>
    </div>

  </div>
</template>
<script>
  import { getFirestore, collection, query, orderBy, limit, getDocs } from "firebase/firestore";

  export default {
    name: 'social-traffic-table',
    props: {
      limit: Number
    },
    created() {
      const db = getFirestore();
      const podQuery = query(
        collection(db, "pod"),
        orderBy("timestamp", "desc"),
        limit(this.limit)
      );
      getDocs(podQuery)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.tableData.push(doc.data());
          });
        })
        .catch((error) => {
          console.error("Error obteniendo documentos:", error);
        });
    },
    mounted(){

    },
    data() {
      return {
        tableData: [],
        pagination: {
          default: 1
        }
      }
    }

  }
</script>
<style>
</style>
